import { api } from '.';
import { Defaults } from '../types/defaults';

export async function getEmailTemplateDefaults(): Promise<Defaults> {
  const response = await api.get('admin/mod/email/defaults');
  return await response.json();
}
